/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalPizzaIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-pizza"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12.03 2Q14.5 2 16.79 2.83Q19.07 3.65 21.1 5.05Q21.6 5.45 21.86 5.99Q22.13 6.53 22.13 7.13Q22.13 7.5 22.01 7.88Q21.9 8.25 21.68 8.6L14.2 19.8Q13.8 20.38 13.22 20.68Q12.65 20.98 12 20.98Q11.35 20.98 10.78 20.68Q10.2 20.38 9.8 19.77L2.35 8.6Q2.13 8.25 2.02 7.88Q1.93 7.5 1.93 7.13Q1.93 6.53 2.19 5.99Q2.45 5.45 2.95 5.05Q4.97 3.65 7.25 2.83Q9.53 2 12.03 2ZM9.85 10.05Q9.85 10.05 10.21 10.05Q10.57 10.05 11.09 9.54Q11.6 9.03 11.6 8.3Q11.6 7.58 11.09 7.06Q10.57 6.55 9.85 6.55Q9.13 6.55 8.61 7.06Q8.1 7.58 8.1 8.3Q8.1 9.03 8.61 9.54Q9.13 10.05 9.85 10.05ZM12.05 15.05Q12.05 15.05 12.41 15.05Q12.78 15.05 13.29 14.54Q13.8 14.03 13.8 13.3Q13.8 12.57 13.29 12.06Q12.78 11.55 12.05 11.55Q11.32 11.55 10.81 12.06Q10.3 12.57 10.3 13.3Q10.3 14.03 10.81 14.54Q11.32 15.05 12.05 15.05Z" fill={color} />
    </svg>
  );
}
